import { useQuery } from 'react-query'

import { get } from '@/pages/hmt/reservation/official-site/utils/fetch'
import { useMusicContext, musicActionType } from '../context/music-context'

export const usePaginationFetch = () => {
  const { musicList, musicDispatch: dispatch } = useMusicContext()

  useQuery<unknown, ReturnData | Error, ReturnData>(
    '/hmt/api/first-impressions/music',
    async () => get(`/api/first-impressions?type=3&disable_page=1`),
    {
      refetchOnWindowFocus: false,
      retry: false,
      onSuccess: (res) => {
        dispatch({
          type: musicActionType.MUSIC_LIST,
          data: res.data?.first_impressions,
        })
      },
    }
  )

  return {
    data: musicList,
  }
}
